import { useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { UserContext } from "../context/UserContext";
import api from '../api/axios';
import getImgUrl from "../helper/getImgUrl";

import Dashboard from "./Dashboard";
import Order from "./dash_component/Order";
import Finance from './dash_component/Finance';
import styles from "../novellum/dash_styles/admindash.module.css"
import ModifyLanding from "./modify components/ModifyLanding";
import ModifyShop from "./modify components/ModifyShop";
import ModifyAbout from './modify components/ModifyAbout';
import ModifyContact from './modify components/ModifyContact';
import AddProduct from './modify components/AddProduct';
import ProductEdit from './modify components/ProductEdit';
import Shipping from "./dash_component/Shipping";
import Clock from "./dash_component/Clock";

import { BsArrow90DegDown } from "react-icons/bs";
import { IoCheckmark } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { PiAirplaneLanding } from "react-icons/pi";
import { PiAirplaneTakeoff } from "react-icons/pi";
import { IoBusinessOutline } from "react-icons/io5";
import { TfiEmail } from "react-icons/tfi";
import { TfiLayoutGrid3 } from "react-icons/tfi";
import { VscGraphLine } from "react-icons/vsc";
import { PiStorefront } from "react-icons/pi";
import { GoTag } from "react-icons/go";
import { AiOutlineEdit } from "react-icons/ai";
import { TfiPackage } from "react-icons/tfi";


const AdminDash = () => {
    const { user, setUser } = useContext(UserContext);
    const [panel, setPanel] = useState("dashboard")
    const [orders, setOrders] = useState([]);

    const navigate = useNavigate();
    
    const handleLogout = async () => {
        try{
            await api.post('/logout');
            setUser(null);
            navigate('/admin');
        } catch (error) {
            console.error('Logout failed', error);
        }
    };

    const fetchOrder = async () => {
        try {
            const res = await api.get('/order');
            setOrders(res.data.orders)
        } catch (error) {
            console.error('Error fetching orders', error);
        }
    };

    useEffect(() => {
        if (!user) return;
        fetchOrder();
    }, [user]);

    const panelChange = (state) => {
        if (state === "dashboard") {
            return (<Dashboard profile={user}/>)
        } else if (state === "orders") {
            return (<Order/>)
        } else if (state === "edit landing") {
            return (<ModifyLanding/>)
        } else if (state === "edit product shop") {
            return (<ModifyShop/>)
        } else if (state === "edit company") {
            return (<ModifyAbout/>)    
        } else if (state === "edit contact") {
            return (<ModifyContact/>)  
        } else if (state === "add product") {
            return (<AddProduct/>)  
        } else if (state === "edit product") {
            return (<ProductEdit/>) 
        } else if (state === "shipping") {
            return(<Shipping/>)   
        } else if (state === "finance") {
            return(<Finance/>)
        }
    }

    return (
        <div className={styles.mainsection}>
            <nav className={styles.navbar}>
                <div className={styles.navInner}>
                    <div className={styles.top_logo}>
                        <div className={styles.logoContainer}>
                            <img src={getImgUrl("g5.svg")} alt="Logo"/>
                        </div>
                
                        <div className={styles.businessName}>
                            <p>{user?.business_name}</p>
                        </div>
                    </div>
                    <div className={styles.middle}>
                        <div className={styles.category}>
                            <p>Dashboads</p>
                            <IoIosArrowDown/>
                        </div>
                        <div className={styles.subCat}>
                            <div className={panel === 'dashboard' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("dashboard")}>
                                <TfiLayoutGrid3 className={styles.subIcon}/>
                                <p>Main Dashboard</p>
                            </div>
                            <div className={panel === 'finance' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("finance")}>
                                <VscGraphLine className={styles.subIcon}/>
                                <p>Finance</p>
                            </div>
                        </div>
                        <div className={styles.category}>
                            <p>Page Management</p>
                            <IoIosArrowDown/>
                        </div>
                        <div className={styles.subCat}>
                            <div className={panel === 'edit landing' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("edit landing")}>
                                <PiAirplaneLanding className={styles.subIcon}/>
                                <p>Landing</p>
                            </div>
                            <div className={panel === 'edit product shop' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("edit product shop")}>
                                <PiStorefront className={styles.subIcon}/>
                                <p>Product Shop</p>
                            </div>
                            <div className={panel === 'edit company' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("edit company")}>
                                <IoBusinessOutline className={styles.subIcon}/>
                                <p>Company</p>
                            </div>
                            <div className={panel === 'edit contact' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("edit contact")}>
                                <TfiEmail className={styles.subIcon}/>
                                <p>Contact</p>
                            </div>
                        </div>
                        <div className={styles.category}>
                            <p>Product Management</p>
                            <IoIosArrowDown/>
                        </div>
                        <div className={styles.subCat}>
                            <div className={panel === 'add product' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("add product")}>
                                <GoTag className={styles.subIcon}/>
                                <p>Add Product</p>
                            </div>
                            <div className={panel === 'edit product' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("edit product")}>
                                <AiOutlineEdit className={styles.subIcon}/>
                                <p>Edit Product</p>
                            </div>
                        </div>
                        <div className={styles.category}>
                            <p>Purchase Order</p>
                            <IoIosArrowDown/>
                        </div>
                        <div className={styles.subCat}>
                            <div className={panel === 'orders' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("orders")}>
                                <TfiPackage className={styles.subIcon}/>
                                <p>Orders</p>
                            </div>
                            <div className={panel === 'shipping' ? styles.subContainerActive : styles.subContainer} onClick={() => setPanel("shipping")}>
                                <PiAirplaneTakeoff className={styles.subIcon}/>
                                <p>Shipping</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.bottomnav}>
                        <div className={styles.account}>
                            <div className={styles.dp} onClick={handleLogout}>
                                <p>PS</p>
                            </div>
                            <div className={styles.accountInfo}>
                                <p>{user?.first_name} {user?.last_name}</p>
                                <p><span>{user?.email}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <div className={styles.dashboard}>
                <div className={styles.topBar}>
                    <div className={styles.bar}>
                        <div className={styles.innerLeft}>
                            <div className={styles.arrow}>
                                <BsArrow90DegDown/>
                            </div>
                            <div>
                                <p>{panel.toUpperCase()}</p>
                            </div>
                        </div>
                        <div className={styles.innerRight}>
                            <Clock/>
                            <div className={styles.webAppName}>
                                <div className={styles.activeApp}>
                                    <IoCheckmark/>
                                </div>
                                <p>{user?.app_name}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.panelContainer}>
                    {panelChange(panel)}
                </div>
            </div>
        </div>
    )
}

export default AdminDash